import { useNotification } from 'context/NotificationContext';
import BellIcon from './BellIcon';

const NotificationButton = () => {
  const { setShow, unreadNotificationsCount } = useNotification();
  return (
    <button
      type="button"
      onClick={() => setShow(true)}
      className="relative flex items-center justify-center"
    >
      {unreadNotificationsCount > 0 && (
        <div className="absolute -top-[0.55rem] right-0.5 flex min-h-8 min-w-8 items-center justify-center rounded-full border-[.2rem] border-brand-white bg-brand-secondary px-2 text-[1rem] font-medium text-brand-white">
          {unreadNotificationsCount}
        </div>
      )}

      <BellIcon className="h-[3rem] w-[3rem] sm:h-[3.5rem] sm:w-[3.5rem]" />
    </button>
  );
};

export { NotificationButton };
